import { Product } from '../types';

export const products: Product[] = [
  {
    id: 1,
    name: 'Facility Management Portal',
    description: 'A powerful dashboard for healthcare facilities to manage shift postings, review onboardings, and oversee staffing activities in real time.',
    featureShort: 'Shift posting, onboarding approvals, and facility metrics.',
    features: [
      'Post and manage open shifts',
      'Approve staff onboarding',
      'Monitor facility staffing metrics',
    ],
    imageUrl: 'https://www.intelycare.com/wp-content/uploads/2023/03/nursing-management-team-walking-together-in-lobby-of-facility.jpeg',
    category: 'Healthcare Staffing',
    demoUrl: 'https://app.vitalhivetech.com/',
    isNew: false
  },
  {
    id: 2,
    name: 'Admin Management Suite',
    description: 'A secure administrative backend for payroll management, shift hour tracking, and automated state/medical license verification.',
    featureShort: 'Automated payroll, hour tracking, and license verification.',
    features: [
      'Payroll and pay stub generation',
      'Automated time calculations',
      'State and medical license verification',
    ],
    imageUrl: 'https://mvnu.edu/content/uploads/2024/01/mvnu-online-difference-between-admin-and-business-management.jpeg.webp',
    category: 'Admin Tools',
    demoUrl: 'https://app.vitalhivetech.com/',
    isNew: false
  },
  {
    id: 3,
    name: 'Clinician App',
    description: 'A mobile-friendly interface for healthcare workers to view schedules, upload credentials, pick open shifts, and track their pay stubs.',
    featureShort: 'Schedules, shift booking, credential uploads, and pay tracking.',
    features: [
      'For RNs, LPNs, STNAs',
      'View and manage schedules',
      'Upload credentials and licenses',
      'Browse open facility shifts and pay stubs',
    ],
    imageUrl: 'https://specials-images.forbesimg.com/imageserve/619ea056b05de2285c025b70/Any-updates-on-this-patient-/960x0.jpg?fit=scale',
    category: 'Workforce App',
    demoUrl: 'https://app.vitalhivetech.com/',
    isNew: false
  },
]; 